import { useAuth } from "#root/components/auth";
import * as Fields from "#root/components/form/fields";
import cookies from "browser-cookies";
import type { ReactNode } from "react";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { collection } from "../schema/signup";
import StandardEditor from "./standard-editor";

export default function CreateAccount({ initialData }: { initialData?: Record<string, unknown> }): ReactNode {
  const auth = useAuth();
  const navigate = useNavigate();

  const formProps = useMemo(
    () => ({
      id: "new",
      initialData,
      affiliate: cookies.get("affiliate"),
      collection,
    }),
    [initialData],
  );

  const handleSave = useCallback(
    ({ authToken }: { authToken?: string }) => {
      //TODO: authToken should be passed in via the row, right now it is returned in a non-conforming way
      auth.setLoginCredentials(authToken!);
      navigate("/account/profile");
    },
    [navigate, auth],
  );

  return (
    <StandardEditor {...formProps} buttonOptions={{ save: { position: "bottom", label: "Create Account" } }} onSave={handleSave}>
      <Fields.Set name="affiliate" className="hidden">
        <Fields.Hidden/>
      </Fields.Set>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6">
        <Fields.Set name="type" className="sm:col-span-2">
          <label>I am looking for data for:</label>
          <Fields.Select required>
            <Fields.Option value="corporation">Commercial Use</Fields.Option>
            <Fields.Option value="individual">Individual Use</Fields.Option>
          </Fields.Select>
          <Fields.Validity/>
        </Fields.Set>
        <Fields.Set name="name">
          <label>Your Full Name</label>
          <Fields.FullName required autoComplete="name"/>
          <Fields.Validity/>
        </Fields.Set>
        <Fields.Set name="company">
          <label>Company Name</label>
          <Fields.CompanyName autoComplete="organization"/>
          <Fields.Validity/>
        </Fields.Set>
        <Fields.Set name="email">
          <label>Your Email Address</label>
          <Fields.Email required autoComplete="email"/>
          <Fields.Validity/>
        </Fields.Set>
        <Fields.Set name="password">
          <label>Password</label>
          <Fields.Password required autoComplete="new-password"/>
          <Fields.Validity/>
        </Fields.Set>
      </div>
    </StandardEditor>
  );
}
